import { MsalAuthenticationResult } from '@azure/msal-react'
import { ThemeProvider } from '@fluentui/react'
import { SkeletonTheme } from 'react-loading-skeleton'
import theme from '@/shared/styles/theme'
import { LocalizationProvider } from '@/shared/components/ADKLocalization'
import { Footer, LogoFull } from '@/shared/components'
import localizationConfig from '@/bootstrap/i18n'

import './MSALErrorRedirect.scss'

export default function MSALErrorRedirect(props: MsalAuthenticationResult) {
  const { error } = props
  return (
    <>
      <LocalizationProvider localizationConfig={localizationConfig} loadingComponent={<></>}>
        <ThemeProvider className='theme-provider' theme={theme}>
          <SkeletonTheme baseColor='#D2D0CE' highlightColor='#EEEEEE'>
            <nav className="c-nav">
              <a href='/' className="c-nav-logo">
                <LogoFull height="40px" fill="#FFFFFF" />
              </a> 
            </nav>
            <main className="msal-error-rdr">
              <h1 className="msal-error-rdr__heading">Temporary Login Issue</h1>
              <div className="msal-error-rdr__container">
                <p>
                  We&apos;re currently experiencing a temporary issue with our external service provider, which is affecting login capabilities on Access CA. Our team is actively working to resolve this as quickly as possible. We apologize for any inconvenience this may cause and appreciate your patience.
                </p>
                <p>
                  If you continue to experience issues with logging in, please don&apos;t hesitate to reach out to us at <a href="mailto:AccessCA@cambridgeassociates.com">AccessCA@cambridgeassociates.com</a>. Our support team is here to assist you. Thank you for your understanding.
                </p>
              </div>
            </main>
            <Footer />
          </SkeletonTheme>
        </ThemeProvider>
      </LocalizationProvider>
    </>
  )
}